<template>
<svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.01898 6.19996L4.83588 8.62807C5.09784 8.62807 5.2113 8.52197 5.34735 8.39456L6.57552 7.28791L9.12042 9.04507C9.58716 9.29032 9.91599 9.16117 10.0419 8.64024L11.7124 1.26027L11.7128 1.25983C11.8609 0.609324 11.4633 0.354947 11.0086 0.51453L1.18964 4.05885C0.519517 4.30409 0.529663 4.65631 1.07572 4.81589L3.58603 5.55206L9.41697 2.1121C9.69139 1.94078 9.9409 2.03557 9.73566 2.2069L5.01898 6.19996Z" fill="white"/>
</svg>
</template>
